// CDNA — Swym cart "Save this product for later?" prompt: drop the trailing quantity.
//
// When an item is removed from cart, Swym shows a "save for later?" prompt whose subtitle
// reads "{title} | {variant} {qty} Qty" (e.g. "Kimba Stardust Florals Dress | 8 1 Qty").
// The merchant wants the quantity gone, leaving "{title} | {variant}".
//
// Swym injects this prompt on demand, so we watch for it with a MutationObserver. To stay
// safe we ONLY touch a text node that BOTH contains the "|" separator AND ends with
// " <number> Qty" — that pairing is unique to this subtitle line, so the wishlist drawer's
// own per-item quantity displays and everything else on the page are left untouched. We only
// ever strip the trailing " N Qty"; nothing is added or restyled.
(function () {
  'use strict';

  var TRAIL = /\s*\b\d+\s*Qty\b\.?\s*$/i; // trailing " 1 Qty" / "1 Qty." on a longer string
  var SWYM = '[class*="swym"], [id*="swym"]';

  function scrubScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      if (v && v.indexOf('|') !== -1 && TRAIL.test(v)) {
        node.nodeValue = v.replace(TRAIL, '');
      }
    }
  }

  function scrub(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SWYM)) scrubScope(root);
    if (root.querySelectorAll) {
      var inner = root.querySelectorAll(SWYM);
      for (var i = 0; i < inner.length; i++) scrubScope(inner[i]);
    }
  }

  function start() {
    scrub(document.body);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) scrub(m.addedNodes[j]);
        if (m.type === 'characterData' && m.target && m.target.parentElement) {
          var host = m.target.parentElement.closest ? m.target.parentElement.closest(SWYM) : null;
          if (host) scrubScope(host);
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // CWV: this observer watches all of <body> (childList + characterData). Arming it at
  // load would add main-thread cost to the critical window on every page. The prompt it
  // fixes only ever appears AFTER a cart action, so we defer arming until the first user
  // interaction — or browser idle, whichever comes first. Interaction-gating can never
  // miss the prompt, and it keeps the observer entirely off the load / LCP path.
  var armed = false;
  function arm() {
    if (armed) return;
    armed = true;
    start();
  }

  ['pointerdown', 'keydown', 'touchstart'].forEach(function (evt) {
    window.addEventListener(evt, arm, { once: true, passive: true });
  });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(arm, { timeout: 4000 });
  } else {
    window.addEventListener('load', function () { setTimeout(arm, 1200); });
  }
})();
